module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Georgie Lee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Georgie Lee loves combining her passion for history and storytelling through romantic fiction. She began writing professionally at a local TV station before moving to Hollywood to work in the entertainment industry.  When not writing, Georgie enjoys reading non-fiction history and watching any movie with a costume and an accent. Please visit  "), _c('a', {
    attrs: {
      "href": "http://www.georgie-lee.com/"
    }
  }, [_vm._v("www.georgie-lee.com")]), _vm._v(" for more information about Georgie and her books.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18uiOP1/tc-custom/9781488004285.jpg?1738382112395",
      "alt": "This image is the cover for the book Miss Marianne's Disgrace"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Miss Marianne's Disgrace\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Judged for her mother’s scandalous life, a young woman finds comfort in music—and the company of a dashing author—in this Regency romance.")]), _c('br'), _c('br'), _vm._v("Trapped in the shadow of her mother’s notoriety, Miss Marianne Domville feels excluded from London society. Her sole comfort is composing at her pianoforte—until author Sir Warren Stevens brings a forbidden thrill of excitement into her solitary existence . . ."), _c('br'), _c('br'), _vm._v("Through his writing, former navy surgeon Warren escapes the memories of cruel days at sea. So when he finds Miss Domville’s music and strength an inspiration, he’s certain the benefits of a partnership with this disgraced beauty will outweigh the risks of scandal . . . if she’ll agree to his proposal!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0